module.exports = __webpack_public_path__ + "static/media/BLIQ-BNB.cb4622c0.png";